<template>
    <div id="app">
        <!-- <keep-alive></keep-alive>  -->
        <router-view v-if="isRouterAlive"/>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            isRouterAlive: true
        }
    },
    provide() {
        return {
            reload: this.reload
        }
    },
    created() {
        // 全局清理已使用的微信 code（必须在最前面执行）
        this._cleanUsedWechatCode()
        
        //在页面加载时读取sessionStorage里的状态信息
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(
                Object.assign(
                    {},
                    this.$store.state,
                    JSON.parse(sessionStorage.getItem("store"))
                )
            );
        }

        // 设置Store
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state))
        })

        window.addEventListener(
            "touchstart",
            function(e) {
                if (e.targetTouches.length === 2) {
                    e.preventDefault()
                }
            },
            { passive: false }
        )
    },
    methods: {
        setStore() {
            //在页面刷新时将vuex里的信息保存到sessionStorage里
        },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = !this.isRouterAlive
            })
        },
        // 全局清理已使用的微信 code
        _cleanUsedWechatCode() {
            console.log('=== 全局清理已使用的微信 code ===')
            console.log('当前 URL:', window.location.href)
            
            // 从 URL 中获取 code
            let code = null
            const urlParams = new URLSearchParams(window.location.search)
            code = urlParams.get('code')
            
            // 如果查询字符串中没有，检查 hash 中
            if (!code && window.location.hash) {
                const hash = window.location.hash
                const hashQueryIndex = hash.indexOf('?')
                if (hashQueryIndex !== -1) {
                    const hashQuery = hash.substring(hashQueryIndex + 1)
                    const hashParams = new URLSearchParams(hashQuery)
                    code = hashParams.get('code')
                }
            }
            
            console.log('检测到的 code:', code)
            
            if (code) {
                // 检查这个 code 是否已经使用过
                const usedCodes = JSON.parse(sessionStorage.getItem('wechat_used_codes') || '[]')
                console.log('已使用的 codes:', usedCodes)
                console.log('当前 code 是否已使用:', usedCodes.includes(code))
                
                if (usedCodes.includes(code)) {
                    console.warn('检测到已使用的 code，立即清理:', code)
                    this._forceCleanCodeFromUrl()
                } else {
                    // 如果这个 code 之前获取 openid 失败过（40029 错误），也应该清理
                    // 检查是否有缓存的失败记录
                    const failedCode = sessionStorage.getItem('wechat_failed_code')
                    if (failedCode === code) {
                        console.warn('检测到之前失败的 code，标记为已使用并清理:', code)
                        usedCodes.push(code)
                        sessionStorage.setItem('wechat_used_codes', JSON.stringify(usedCodes))
                        sessionStorage.removeItem('wechat_failed_code')
                        this._forceCleanCodeFromUrl()
                    } else {
                        console.log('code 未使用过，保留')
                    }
                }
            } else {
                console.log('URL 中没有 code 参数')
            }
        },
        // 强制清理 URL 中的 code 参数
        _forceCleanCodeFromUrl() {
            let cleaned = false
            let newUrl = window.location.origin + window.location.pathname
            
            // 1. 清理查询字符串中的 code 和 state
            if (window.location.search) {
                const urlParams = new URLSearchParams(window.location.search)
                if (urlParams.has('code') || urlParams.has('state')) {
                    urlParams.delete('code')
                    urlParams.delete('state')
                    const newSearch = urlParams.toString()
                    if (newSearch) {
                        newUrl += '?' + newSearch
                    }
                    cleaned = true
                } else if (window.location.search) {
                    newUrl += window.location.search
                }
            }
            
            // 2. 清理 hash 中的 code 和 state，但保留路由路径
            if (window.location.hash) {
                const hash = window.location.hash
                const hashQueryIndex = hash.indexOf('?')
                if (hashQueryIndex !== -1) {
                    const hashPath = hash.substring(0, hashQueryIndex)
                    const hashQuery = hash.substring(hashQueryIndex + 1)
                    const hashParams = new URLSearchParams(hashQuery)
                    
                    if (hashParams.has('code') || hashParams.has('state')) {
                        hashParams.delete('code')
                        hashParams.delete('state')
                        const newHashQuery = hashParams.toString()
                        newUrl += hashPath + (newHashQuery ? '?' + newHashQuery : '')
                        cleaned = true
                    } else {
                        newUrl += hash
                    }
                } else {
                    newUrl += hash
                }
            }
            
            if (cleaned) {
                // 强制更新 URL
                window.history.replaceState({}, '', newUrl)
                console.log('已强制清理 URL 中的 code 参数，新 URL:', newUrl)
            }
        }
    }
};
</script>

<style lang="sass">
#app
  height: 100%
  width: 100%
</style>



// WEBPACK FOOTER //
// src/App.vue